<template>
  <div class="multi-assign-field" :class="{ disabled: !!disabled }">
    <Field
      v-if="isText && !disabled"
      ref="input"
      type="text"
      :name="`${name}_field_control`"
      :label="label"
      :labelClass="labelClass"
      v-model="current"
      @enter="add"
    />
    <Field
      v-else-if="isSelect && !disabled"
      ref="input"
      type="select"
      :name="`${name}_field_control`"
      :label="label"
      :labelClass="labelClass"
      v-model="current"
      :options="options"
      :hideSelectEmptyOption="true"
    />
    <div v-if="!!disabled && !!label" class="element">
      <label>{{ label }}</label>
    </div>
    <div v-if="assigned.length > 0" class="multi-assign-values">
      <a
        v-for="(item, i) in assigned"
        :key="i"
        class="pill"
        href="#"
        @click.prevent="remove(item)"
      >
        <span class="text">{{ isSelect ? itemLabel(item) : item }}</span>
        <icon icon="remove" class="icon" />
        <input type="hidden" :name="`${name}[]`" :value="item" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: { type: String, required: true },
    value: { type: Array, default: () => [] },
    type: { type: String, default: "text" }, // supported values: "text" or "select"
    options: { type: Array, default: () => [] }, // required for "select" type
    label: { type: String },
    validate: { type: String },
    labelClass: { type: String },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      assigned: [],
      current: null,
    };
  },
  computed: {
    isText() {
      return this.type == "text";
    },
    isSelect() {
      return this.type == "select";
    },
  },
  watch: {
    value(val) {
      this.assigned = val;
    },
    assigned(val) {
      this.$emit("input", val);
    },
    current(val) {
      if (this.isSelect) {
        this.add();
      }
    },
  },
  methods: {
    add() {
      if (this.assigned.includes(this.current)) {
        var msg = this.isText
          ? "You have already added an item of the same name."
          : "You have already assigned the selected item.";
        alert(msg);
        return;
      } else if (!this.current) {
        return;
      }
      this.assigned.push(this.current);
      this.current = null;
    },
    remove(item) {
      let assigned = this.assigned;
      this.assigned = [];
      this.assigned = assigned.filter((val) => {
        return val != item;
      });
    },
    itemLabel(item) {
      let label = "";
      this.options.forEach((option) => {
        if (option.value == item) {
          label = option.label;
        }
      });
      return label;
    },
  },
  mounted() {
    this.assigned = this.value || [];
  },
};
</script>

<style scoped>
.multi-assign-field.disabled .multi-assign-values .pill {
  pointer-events: none;
}
</style>